import Presenter from 'microcosm/addons/presenter'
import Historical from '../../components/strategies/historical'

import {
  currentAggregates,
  focusedAggregate,
  highlight,
  byRegion
} from '../../queries'

class StrategiesHistoricalPresenter extends Presenter {
  view = Historical

  setup(repo) {
    repo.index(
      'series',
      'strategies,ui.focused,ui.region',
      byRegion('strategies')
    )
  }

  getModel({ location }) {
    const { query } = location

    return {
      query: query,
      region: state => state.ui.region,
      series: this.repo.memo('series', currentAggregates(query)),
      strategies: this.repo.memo('series', highlight(query)),
      aggregate: this.repo.memo('series', highlight(query), focusedAggregate)
    }
  }
}

export default StrategiesHistoricalPresenter



// WEBPACK FOOTER //
// ./src/presenters/strategies/historical.js